import { RealmTypesValues, realmTypeConfigs } from 'RealmModule/constants/realm';

export const getRealmLabel = (realmType: RealmTypesValues) => {
  return realmTypeConfigs[realmType]?.label;
};
